import React from 'react';

import TrustSection from 'dpl/common/components/TrustSection';

export default function Accreditation() {
  return (
    <div className="PrismicAccreditation container">
      <div className="row">
        <div className="col-xl-9 offset-xl-1">
          <TrustSection />
        </div>
      </div>
    </div>
  );
}
